<div class="pro_inventory" *ngIf="stock <= 5">
    <p class="active">
      Hurry! We have only {{ stock }} product in stock.
    </p>
    <div class="inventory-scroll nostripes active">
      <span style="width: 95%;"></span>
    </div>
</div>